import { z } from "zod"
import { ZodURLSearchParamSerializer } from "zod-urlsearchparams"

export const groupSearchSchema = z.object({
  search: z.string(),
})

export const groupSearchSerializer = new ZodURLSearchParamSerializer(groupSearchSchema)
